import { styled, Table, TableBody, TableCell, tableCellClasses, TableHead, TableRow } from "@mui/material";
import { FC } from "react";
import { TableRow as ngtTableRow } from "../../../api/dtos/dtos";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.grey[300],
        color: theme.palette.common.black,
        fontWeight: 'bold',
        borderBottom: '1px solid black'
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.grey[50],
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        borderBottom: '1px solid black'
    },
}));

interface INGTTableProps {
    tableId: string,
    tableTitle: string,
    tableRows: ngtTableRow[] | undefined,
}

const NGTTable: FC<INGTTableProps> = ({
    tableId,
    tableTitle,
    tableRows
}) => {

    return (
        <Table
            id={tableId}
            sx={{ 
                width: '97%',
                margin: '10px'
            }}
        >
            <TableHead>
                <TableRow>
                    <StyledTableCell>{tableTitle}</StyledTableCell>
                    <StyledTableCell align="right">This Period</StyledTableCell>
                    <StyledTableCell align="right">YTD</StyledTableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {tableRows?.length === 0  && (
                    <StyledTableRow key={`${tableTitle}-empty`}>
                        <StyledTableCell>
                            No data available in table
                        </StyledTableCell>
                        <StyledTableCell>
                        </StyledTableCell>
                        <StyledTableCell>
                        </StyledTableCell>
                    </StyledTableRow>
                )}
                {tableRows?.map((row) => (
                    <StyledTableRow key={`${row.name}-${row.period}-${row.ytd}`}>
                        <StyledTableCell 
                            component="th" 
                            scope="row"
                            sx={{
                                fontWeight: row.bold ? 'bold' : 'normal',
                                paddingLeft: row.indent ? '50px' : '15px'
                            }}
                        >
                            {row.name}
                        </StyledTableCell>
                        <StyledTableCell 
                            align="right"
                            sx={{
                                fontWeight: row.bold ? 'bold' : 'normal'
                            }}
                        >
                            {row.period}
                        </StyledTableCell>
                        <StyledTableCell 
                            align="right"
                            sx={{
                                fontWeight: row.bold ? 'bold' : 'normal'
                            }}
                        >
                            {row.ytd}
                        </StyledTableCell>
                    </StyledTableRow>
                ))}
            </TableBody>
        </Table>
    );
}

export default NGTTable;